// extracted by mini-css-extract-plugin
export var addressAddress = "detailsAddress-module--address-address--c11cb";
export var addressBody = "detailsAddress-module--address-body--d4ae9";
export var addressCarouselContainer = "detailsAddress-module--address-carousel-container--5b8cf";
export var addressContact = "detailsAddress-module--address-contact--382bc";
export var addressContent = "detailsAddress-module--address-content--f9f62";
export var addressContentContainer = "detailsAddress-module--address-content-container--551a5";
export var addressFooter = "detailsAddress-module--address-footer--3a4b1";
export var addressFooterBack = "detailsAddress-module--address-footer-back--d8a3a";
export var addressPlace = "detailsAddress-module--address-place--edc70";
export var addressPlaceIcon = "detailsAddress-module--address-place-icon--f02c7";
export var addressPlaceTitle = "detailsAddress-module--address-place-title--a2ebc";
export var addressTitle = "detailsAddress-module--address-title--b9eed";
export var pageAddress = "detailsAddress-module--page-address--dbc18";
export var pageAddressAdditionalInfos = "detailsAddress-module--page-address-additional-infos--a8241";
export var separator = "detailsAddress-module--separator--2f6ea";